import { createfareRulesHandlers } from './handlers';
export const fareRulesHandlers = createfareRulesHandlers();